import { render, staticRenderFns } from "./effectCard.vue?vue&type=template&id=4f9eb49d&scoped=true"
import script from "./effectCard.vue?vue&type=script&lang=js"
export * from "./effectCard.vue?vue&type=script&lang=js"
import style0 from "./effectCard.vue?vue&type=style&index=0&id=4f9eb49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9eb49d",
  null
  
)

export default component.exports